import {
  fromUTCtoZoneFormatted,
  STORE_KEY_LIST,
  storeGet
} from 'mailup-react-helpers'
import {
  Chip,
  Flex,
  FlexItem,
  Grid,
  GridCell,
  Link,
  LINK_VARIANT_EXTRALIGHT,
  PanelCollapsible,
  SPACING_8,
  SpacingVertical,
  Text,
  TEXT_VARIANT_BOLD,
  Title,
  TITLE_VARIANT_M,
  TITLE_VARIANT_S
} from 'mailup-web-components'
import moment from 'moment-timezone'
import { changeWizardStepCallback } from 'Pages/Task/recoil/callbacks/callbacks'
import {
  ACTION_MOVE_COPY,
  exceptionsState,
  recapState,
  rssFeedsState,
  taskState
} from 'Pages/Task/recoil/state/task'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import {
  ACTIVITY_OPTIONS,
  CHOOSE_OPTIONS,
  DAYS,
  EVERY_HOUR_OPTIONS,
  EVERY_OPTIONS,
  MONTHS
} from '../../Step4/components/const'

const Frequency = () => {
  const intl = useIntl()

  const [{ frequencyExpandend }, setRecapState] = useRecoilState(recapState)
  const task = useRecoilValue(taskState)
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)
  const {
    activiteFor,
    StartDate,
    EndDate,
    FrequencyBlackoutDate,

    NotInWeekends,
    urlFrequencyEnabled,
    Url,
    UrlFrequency
  } = useRecoilValue(exceptionsState)
  const changeWizardStep = useRecoilCallback(changeWizardStepCallback, [])
  const rssFeeds = useRecoilValue(rssFeedsState)

  const onChangePanel = () => {
    setRecapState((prev) => ({
      ...prev,
      frequencyExpandend: !prev.frequencyExpandend
    }))
  }

  const goToStep = () => {
    changeWizardStep(4)
  }

  const getFrequencyMain = () => {
    if (task.Frequency.KindDateFrequency === 'w') {
      return task.Frequency.ChoosenDays.map(
        (e, i) =>
          e.DayOfWeek !== '' &&
          intl.formatMessage({
            id: DAYS.find((k) => k.value === e.DayOfWeek).label
          }) + (i < task.Frequency.ChoosenDays.length - 1 ? ', ' : '')
      )
    } else if (
      task.Frequency.KindDateFrequency === 'm' ||
      task.Frequency.KindDateFrequency === 'y'
    ) {
      return task.Frequency.ChoosenDays[0].FixedDay
        ? task.Frequency.ChoosenDays[0].DayOfMonth
        : intl.formatMessage({
            id: EVERY_OPTIONS.find(
              (f) => f.value === task.Frequency.ChoosenDays[0].WeekOfMonth
            ).label
          }) +
            ' ' +
            intl.formatMessage({
              id: DAYS.find(
                (f) => f.value === task.Frequency.ChoosenDays[0].DayOfWeek
              ).label
            })
    } else if (task.Frequency.KindDateFrequency === 'd') {
      return '-'
    }
  }

  return (
    <PanelCollapsible
      title={intl.formatMessage({ id: 'Load.Task.Step4ActFreq' })}
      collapsed={!frequencyExpandend}
      onChange={onChangePanel}
      beforeCollapseChildren={
        <Link
          data-mu-test='task-5-frequency'
          onClick={goToStep}
          variant={LINK_VARIANT_EXTRALIGHT}
        >
          {intl.formatMessage({ id: 'Load.Task.ReviewEdit' })}
        </Link>
      }
    >
      <Grid cols={3}>
        <GridCell span={1} variantVertical='vertical_big'>
          <Title variant={TITLE_VARIANT_S}>
            {intl.formatMessage({ id: 'Load.Task.ReviewActivateEvery' })}
          </Title>
          <SpacingVertical variant={SPACING_8} />
          <Text>
            {task.Frequency.KindDateFrequency === 'd' &&
              task.Frequency.DateFrequency +
                ' ' +
                intl.formatMessage({ id: CHOOSE_OPTIONS[0].label })}
            {task.Frequency.KindDateFrequency === 'w' &&
              task.Frequency.DateFrequency +
                ' ' +
                intl.formatMessage({ id: CHOOSE_OPTIONS[1].label })}
            {task.Frequency.KindDateFrequency === 'm' &&
              task.Frequency.DateFrequency +
                ' ' +
                intl.formatMessage({ id: CHOOSE_OPTIONS[2].label })}
            {task.Frequency.KindDateFrequency === 'y' &&
              task.Frequency.DateFrequency +
                ' ' +
                intl.formatMessage({ id: CHOOSE_OPTIONS[3].label }) +
                ' ' +
                intl.formatMessage({
                  id: 'Load.Task.FrequencyMainSelectLabelMonth'
                }) +
                ' ' +
                intl.formatMessage({
                  id: MONTHS.find(
                    (f) =>
                      parseInt(f.value) === task.Frequency.ChoosenDays[0].Month
                  ).label
                })}
          </Text>
        </GridCell>

        <GridCell span={1}>
          <Title variant={TITLE_VARIANT_S}>
            {((task.Frequency.KindDateFrequency === 'm' ||
              task.Frequency.KindDateFrequency === 'y') &&
              task.Frequency.ChoosenDays[0].FixedDay) ||
            task.Frequency.KindDateFrequency === 'd'
              ? intl.formatMessage({
                  id: 'Load.Task.FrequencyMainSelectLabelDay'
                })
              : intl.formatMessage({
                  id: 'Load.Task.FrequencyMainSelectLabelEvery'
                })}
          </Title>
          <SpacingVertical variant={SPACING_8} />
          <Text> {getFrequencyMain()} </Text>
        </GridCell>

        <GridCell span={1}>
          <Title variant={TITLE_VARIANT_S}>
            {intl.formatMessage({ id: 'Load.Task.ReviewActivationTime' })}
          </Title>
          <SpacingVertical variant={SPACING_8} />
          <Text>
            {task.Frequency.DailyFrequency !== 0 &&
              intl.formatMessage({
                id: EVERY_HOUR_OPTIONS.find(
                  (e) => e.value === task.Frequency.DailyFrequency
                ).label
              })}
            {task.Frequency.DailyFrequency === 0 &&
              (task.Frequency.StartHour < 10
                ? '0' + task.Frequency.StartHour
                : task.Frequency.StartHour) +
                ':' +
                (task.Frequency.StartMinute < 10
                  ? '0' + task.Frequency.StartMinute
                  : task.Frequency.StartMinute)}
          </Text>
        </GridCell>

        <GridCell span={3}>
          <Title variant={TITLE_VARIANT_S}>
            {intl.formatMessage({ id: 'Load.Task.FrequencyActivityTitle' })}
          </Title>
          <SpacingVertical variant={SPACING_8} />
          <Text>
            {intl.formatMessage({
              id: ACTIVITY_OPTIONS.find((e) => e.value === activiteFor).label
            })}{' '}
            {activiteFor === 'FromToDate' &&
              intl.formatMessage({ id: 'Load.Task.ToDay' })}{' '}
            <Text htmlElement='span' variant={TEXT_VARIANT_BOLD}>
              {moment(StartDate).format('YYYY-DD-MM')}
            </Text>{' '}
            {activiteFor === 'FromToDate' &&
              intl.formatMessage({ id: 'Load.Task.FromDay' })}{' '}
            <Text htmlElement='span' variant={TEXT_VARIANT_BOLD}>
              {activiteFor === 'FromToDate' &&
                moment(EndDate).format('YYYY-DD-MM')}
            </Text>
          </Text>
        </GridCell>
      </Grid>
      {task.Detail.Action !== ACTION_MOVE_COPY && (
        <>
          {((task.Frequency.BlackoutStartHour &&
            task.Frequency.BlackoutEndHour) ||
            FrequencyBlackoutDate.length > 0 ||
            NotInWeekends ||
            urlFrequencyEnabled) && (
            <>
              <SpacingVertical />
              <Title variant={TITLE_VARIANT_M}>
                {intl.formatMessage({
                  id: 'Load.Task.FrequencyExceptionTitle'
                })}
              </Title>
              <SpacingVertical variant={SPACING_8} />
              <Grid>
                <GridCell span={1}>
                  <Title variant={TITLE_VARIANT_S}>
                    {intl.formatMessage({
                      id: 'Load.Task.ReviewExcludedSpecificDates'
                    })}
                  </Title>
                  <SpacingVertical variant={SPACING_8} />
                  {FrequencyBlackoutDate.filter((e) => !e.Recurring).length ===
                    0 && <Text>-</Text>}
                  <Flex margin='0 0 0 24px' flexWrap='wrap' gap='8px'>
                    {FrequencyBlackoutDate.filter((e) => !e.Recurring).map(
                      (e, index) => (
                        <FlexItem key={index}>
                          <Chip
                            icon=''
                            label={fromUTCtoZoneFormatted(
                              e.Date,
                              TimeZoneCode,
                              'YYYY-MM-DD'
                            )}
                            value={e}
                          />
                        </FlexItem>
                      )
                    )}
                  </Flex>
                </GridCell>

                <GridCell span={1}>
                  <Title variant={TITLE_VARIANT_S}>
                    {intl.formatMessage({
                      id: 'Load.Task.ReviewExcludedRecurrentDates'
                    })}
                  </Title>
                  <SpacingVertical variant={SPACING_8} />
                  {FrequencyBlackoutDate.filter((e) => e.Recurring).length ===
                    0 && <Text>-</Text>}
                  <Flex margin='0 0 0 24px' flexWrap='wrap' gap='8px'>
                    {FrequencyBlackoutDate.filter((e) => e.Recurring).map(
                      (e, index) => (
                        <FlexItem key={index}>
                          <Chip
                            icon=''
                            key={index}
                            label={fromUTCtoZoneFormatted(
                              e.Date,
                              TimeZoneCode,
                              'MM-DD'
                            )}
                            value={e}
                          />
                        </FlexItem>
                      )
                    )}
                  </Flex>
                </GridCell>

                <GridCell span={1}>
                  <Title variant={TITLE_VARIANT_S}>
                    {intl.formatMessage({ id: 'Load.Task.ReviewExcludedTime' })}
                  </Title>
                  <SpacingVertical variant={SPACING_8} />
                  {!task.Frequency.BlackoutEndHour &&
                  !task.Frequency.BlackoutStartHour ? (
                    <>
                      <Text>-</Text>
                    </>
                  ) : (
                    <>
                      <Text>
                        {task.Frequency.BlackoutStartHour.split(
                          'T'
                        )[1].substring(
                          0,
                          task.Frequency.BlackoutStartHour.split('T')[1]
                            .length - 4
                        )}{' '}
                        -{' '}
                        {task.Frequency.BlackoutEndHour.split('T')[1].substring(
                          0,
                          task.Frequency.BlackoutEndHour.split('T')[1].length -
                            4
                        )}
                      </Text>
                    </>
                  )}
                </GridCell>
              </Grid>
              <Flex
                margin='0 0 0 32px'
                padding='16px 0 0 0'
                flexDirection='column'
                gap='16px'
              >
                {NotInWeekends && (
                  <>
                    <li>
                      <Text>
                        {intl.formatMessage({
                          id: 'Load.Task.FrequencyExcludeWeekend'
                        })}
                      </Text>
                    </li>
                  </>
                )}
                {urlFrequencyEnabled && (
                  <>
                    <li>
                      <Text htmlElement='span'>
                        {intl.formatMessage({
                          id: 'Load.Task.FrequencyExcludeFeedFromDateLabelFirst'
                        })}
                      </Text>{' '}
                      <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
                        {rssFeeds.items.find((f) => f.value === Url)
                          ? rssFeeds.items.find((f) => f.value === Url).label
                          : '-'}
                      </Text>{' '}
                      <Text htmlElement='span'>
                        {intl.formatMessage({
                          id: 'Load.Task.FrequencyExcludeFeedFromDateLabelSecond'
                        })}
                      </Text>{' '}
                      <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
                        {UrlFrequency}
                      </Text>{' '}
                      <Text htmlElement='span'>
                        {intl.formatMessage({
                          id: 'Load.MailupCommon.Hours'
                        })}
                      </Text>
                    </li>
                  </>
                )}
              </Flex>
            </>
          )}
          <SpacingVertical />
        </>
      )}
      {task.Detail.Action === ACTION_MOVE_COPY && <SpacingVertical />}
      <Title variant={TITLE_VARIANT_M}>
        {intl.formatMessage({
          id: 'Load.Task.FrequencyOnConflictTitle'
        })}
      </Title>
      <SpacingVertical variant={SPACING_8} />
      {task.Frequency.AsSoonAsPossible &&
        intl.formatMessage({
          id: 'Load.Task.FrequencyOnConflictActivateAsap'
        })}
      {!task.Frequency.AsSoonAsPossible &&
        intl.formatMessage({
          id: 'Load.Task.FrequencyOnConflictDoNotActivate'
        })}
    </PanelCollapsible>
  )
}

export default Frequency
